import without from 'lodash/without'
import _ from 'lodash'

export function retrieveEventIdSuccess(state, { eventId }) {
    state.eventId = eventId
}

export function retrieveEventIdError(state) {
	state.isBadEvent = true
}

export function openWorkspace(state) {
    state.workspace = {
		entries: [],
		fieldMappings: [],
        validationRequest: null,
        errors: [],
        csv: null,
        isSubmitting: false,
        wasSubmitted: false,
	}
}

export function setCsv(state, csv) {
    state.workspace.csv = csv
}

export function clearCsv(state) {
    state.workspace.csv = null
}

export function closeWorkspace(state) {
    state.workspace = null
}

export function retrieveEventStart(state, { eventId }) {
    // TODO
}

export function retrieveEventSuccess(state, { eventId, event }) {
    state.event = event
}

export function retrieveEventError(state, { eventId, error }) {
    // TODO
}

export function retrieveOwnInfoStart(state) {
    state.me = null
}

export function retrieveOwnInfoSuccess(state, { account }) {
    state.me = account
}

export function retrieveOwnInfoError(state) {
    // TODO
}

export function retrieveAccountsStart(state) {
    state.accountRetrieval = {
        isFinished: false,
        errors: [],
    }
}

export function retrieveAccountsSuccess(state, { accounts }) {
    state.auth.accounts = accounts
    state.accountRetrieval.isFinished = true
}

export function retrieveAccountsError(state, { errors }) {
    state.accountRetrieval.isFinished = true
    state.accountRetrieval.errors = errors
}

export function chooseAccountStart(state, { accountId }) {
    state.loginSubmission = {
        accountId,
        isFinished: false,
        errors: [],
    }
}

export function chooseAccountSuccess(state, { accountId, token }) {
    state.auth.accounts = null
    state.auth.integratedIdentity = { accountId, token }

    state.loginSubmission.isFinished = true
}

export function chooseAccountError(state, { errors }) {
    state.loginSubmission.isFinished = true
    state.loginSubmission.errors = errors
}

export function switchAccountStart(state, { accountId }) {
    // TODO
}

export function switchAccountSuccess(state, { accountId, token }) {
	state.auth.integratedIdentity = { accountId, token }
}

export function switchAccountError(state) {
    // TODO
}

export function setIntegratedIdentity(state, { accountId, token }) {
	state.auth.integratedIdentity = { accountId, token }
}

export async function clearAccountRetrieval(state) {
	state.accountRetrieval = null
}

export async function clearLoginSubmission(state) {
	state.loginSubmission = null
}

export function submitRegistrationStart(state) {
    state.registrationSubmission = {
        isFinished: false,
        errors: [],
    }
}

export function submitRegistrationSuccess(state, { identity }) {
    state.auth.nonIntegratedIdentity = identity
    state.registrationSubmission.isFinished = true
}

export function submitRegistrationError(state, { errors }) {
    state.registrationSubmission.errors = errors
    state.registrationSubmission.isFinished = true
}

export function clearRegistrationSubmission(state) {
    state.registrationSubmission = null
}

export function clearIdentity(state) {
    state.auth.integratedIdentity = null
    state.auth.nonIntegratedIdentity = null
}

export function validateEntriesStart(state, { nonce }) {
    state.workspace.validationRequest = {
        nonce,
        isFinished: false,
    }
}

export function validateEntriesSuccess(state, { nonce, errors }) {
    if (
		state.workspace.validationRequest &&
		state.workspace.validationRequest.nonce === nonce
	) {
		state.workspace.errors = errors
		state.workspace.validationRequest.isFinished = true
    }
}

export function validateEntriesError(state, { nonce, errors }) {
    if (
		state.workspace.validationRequest &&
		state.workspace.validationRequest.nonce === nonce
	) {
        state.workspace.validationRequest.isFinished = true
    }
}

export function submitRosterStart(state) {
	state.workspace.isSubmitting = true
}

export function submitRosterSuccess(state, { teamId }) {
	state.workspace.isSubmitting = false
    state.workspace.wasSubmitted = true
    
    const team = state.event.teams.find(t => t.id === teamId)
    team.isRostered = true
}

export function submitRosterError(state) {
	state.workspace.isSubmitting = false
    state.hadSubmissionError = true
}

export function addFieldMapping(state, { fieldName, columnName }) {
    // If there's already a mapping for this field or column, remove it
    removeMappingByField(state, { fieldName })
    removeMappingByColumn(state, { columnName })

    state.workspace.fieldMappings.push({ fieldName, columnName })
}

export function removeMappingByField(state, { fieldName }) {
	state.workspace.fieldMappings = state.workspace.fieldMappings.filter(
		(m) => m.fieldName !== fieldName
	)
}

export function removeMappingByColumn(state, { columnName }) {
	state.workspace.fieldMappings = state.workspace.fieldMappings.filter(
		(m) => m.columnName !== columnName
	)
}

export function clearMappings(state) {
    state.workspace.fieldMappings = []
}

export function overwriteEntries(state, { entries }) {
    state.workspace.entries = entries
}

export function addEntry(state, entry) {
	state.workspace.entries = _.uniqBy(
        [ ...state.workspace.entries, entry ],
        entry => entry.id || entry
    )
}

export function addEntries(state, entries) {
	state.workspace.entries = _.uniqBy(
        [ ...state.workspace.entries, ...entries ],
        entry => entry.id || entry
    )
}

export function deleteEntry(state, entry) {
    state.workspace.entries = without(state.workspace.entries, entry) // TODO
}
